<template>
  <v-container>
    <v-layout row>
      <v-flex xs12 sm6 offset-sm3>
        <v-card class="card--flex-toolbar">
          <v-toolbar card class="white" prominent>
            <v-toolbar-title class="body-4 primary--text">{{ $t("forget_password") }}</v-toolbar-title>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text>
            <v-container>
              <form @submit.prevent="createNewPassword">
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="email"
                      :label="$t('email')"
                      id="email"
                      v-model="email"
                      type="email"
                      required
                      autofocus></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row>
                  <v-flex xs6 class="text-xs-left">
                    <v-btn type="submit" :disabled="loading" :loading="loading">
                      {{ $t("password_change") }}
                      <span slot="loader" class="custom-loader">
                        <v-icon light>cached</v-icon>
                      </span>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { HTTP } from '../../utils'
export default {
  data () {
    return {
      email: '',
      loading: false
    }
  },

  methods: {
    createNewPassword () {
      let regex = new RegExp('^[a-zA-Z0-9-_.+]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')
      if (!this.email || !regex.test(this.email)) {
        this.$swal({
          title: this.$t('warning'),
          text: this.$t('required_email'),
          type: 'warning'
        })
        return
      }
      this.loading = true
      HTTP.post('forget-password', { email: this.email })
        .then(response => {
          if (response.data.status > 0) {
            this.$swal({
              position: 'bottom-right',
              type: 'success',
              title: this.$t('password_change_done'),
              html: this.$t('password_change_done_text'),
              confirmButtonText: this.$t('close')
            })
          } else {
            throw new Error(response.data.message)
          }
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          console.log('ERROR Blacklist - profile: ' + error)
          this.$swal({
            position: 'bottom-right',
            type: 'error',
            title: this.$t('password_change_error'),
            text: error.message,
            showConfirmButton: false,
            timer: 3000
          })
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/User/ForgetPassword.vue